import React, { useState, useEffect } from 'react';
import './HouseListingForm.css';
import { collection, query, where, addDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase'; 
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth } from './firebase';
import Tesseract from 'tesseract.js';
import imageCompression from "browser-image-compression";

import { v4 as uuidv4 } from 'uuid';

import MapModal from './MapModal';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { 
  FaSnowflake, FaTint, FaLightbulb, FaUtensils, FaBox, 
  FaMapMarkerAlt, FaArrowUp, FaCar, FaDoorOpen, 
  FaSwimmingPool, FaPaw, FaFire 
} from 'react-icons/fa';


import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase"; 
const extractLatLngFromGoogle = async (googleLink) => {
  try {
    // Try @lat,lng
    let match = googleLink.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
    if (!match) {
      // Try q=lat,lng format
      match = googleLink.match(/q=(-?\d+\.\d+),(-?\d+\.\d+)/);
    }
    if (match) {
      return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
    }
    alert("❌ Invalid Google Maps link format.");
    return { lat: null, lng: null };
  } catch (err) {
    console.error("Error extracting lat/lng:", err);
    return { lat: null, lng: null };
  }
};




// haversine distance (km)
const getDistanceKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // km
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return +(R * c).toFixed(2);
};
function RentListingForm() {
  const [planType, setPlanType] = useState('basic'); // ✅ DECLARE HERE FIRST
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    pgName: '',
    occupancy: '',
    description: '',
    name: '',
    whatsapp: '',
    email: '',
    contactTime: '',
    amenities: [],
    address: '',
    mapLink: '',
    rent: '',
    deposit: '',
    negotiable: '',
    roomType: '', 
  });

   const navigate = useNavigate();
    const [showMap, setShowMap] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [phoneVerified, setPhoneVerified] = useState(false);
    
    const [agreed, setAgreed] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false); // <-- ADD THIS

const [thumbnail, setThumbnail] = useState(null);
const [thumbnailPreview, setThumbnailPreview] = useState(null);
const [coverImages, setCoverImages] = useState([]);
const [coverPreviews, setCoverPreviews] = useState([]);
const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
const [agreementChecked, setAgreementChecked] = useState(false);
const [billFile, setBillFile] = useState(null);
const [images, setImages] = useState([]);
const [videoFile, setVideoFile] = useState(null);
const [videoPreview, setVideoPreview] = useState(null);
const [videoError, setVideoError] = useState('');


const newDocRef = doc(collection(db, 'rent-listings'));  // <-- changed here
const generateCustomListingId = () => {
  const randomNum = Math.floor(10000 + Math.random() * 90000); // 5-digit random number
  return `agh_listing_${randomNum}`;
};
const cityBoundaries = {
  Guwahati: [
    { lat: 26.1445, lng: 91.7362 },
    { lat: 26.1600, lng: 91.7362 },
    { lat: 26.1600, lng: 91.7700 },
    { lat: 26.1445, lng: 91.7700 },
  ],
  Jorhat: [
    { lat: 26.7440, lng: 94.2030 },
    { lat: 26.7500, lng: 94.2030 },
    { lat: 26.7500, lng: 94.2200 },
    { lat: 26.7440, lng: 94.2200 },
  ],
  Dergaon: [
    { lat: 26.7675, lng: 94.0520 },
    { lat: 26.7775, lng: 94.0520 },
    { lat: 26.7775, lng: 94.0720 },
    { lat: 26.7675, lng: 94.0720 },
  ],
  Dibrugarh: [
    { lat: 27.4720, lng: 94.9100 },
    { lat: 27.4900, lng: 94.9100 },
    { lat: 27.4900, lng: 94.9400 },
    { lat: 27.4720, lng: 94.9400 },
  ],
  Silchar: [
    { lat: 24.8100, lng: 92.7700 },
    { lat: 24.8300, lng: 92.7700 },
    { lat: 24.8300, lng: 92.8000 },
    { lat: 24.8100, lng: 92.8000 },
  ],
  Tezpur: [
    { lat: 26.6330, lng: 92.7900 },
    { lat: 26.6500, lng: 92.7900 },
    { lat: 26.6500, lng: 92.8200 },
    { lat: 26.6330, lng: 92.8200 },
  ],
  Nagaon: [
    { lat: 26.3500, lng: 92.6800 },
    { lat: 26.3700, lng: 92.6800 },
    { lat: 26.3700, lng: 92.7100 },
    { lat: 26.3500, lng: 92.7100 },
  ],
  Tinsukia: [
    { lat: 27.4800, lng: 95.3400 },
    { lat: 27.5000, lng: 95.3400 },
    { lat: 27.5000, lng: 95.3700 },
    { lat: 27.4800, lng: 95.3700 },
  ],
  Kokrajhar: [
    { lat: 26.4200, lng: 90.2800 },
    { lat: 26.4400, lng: 90.2800 },
    { lat: 26.4400, lng: 90.3100 },
    { lat: 26.4200, lng: 90.3100 },
  ],
  Bongaigaon: [
    { lat: 26.4700, lng: 90.5600 },
    { lat: 26.4900, lng: 90.5600 },
    { lat: 26.4900, lng: 90.5900 },
    { lat: 26.4700, lng: 90.5900 },
  ],
  Mangaldoi: [
    { lat: 26.4300, lng: 92.0400 },
    { lat: 26.4500, lng: 92.0400 },
    { lat: 26.4500, lng: 92.0700 },
    { lat: 26.4300, lng: 92.0700 },
  ],
  Sivasagar: [
    { lat: 26.9800, lng: 94.6400 },
    { lat: 26.9950, lng: 94.6400 },
    { lat: 26.9950, lng: 94.6700 },
    { lat: 26.9800, lng: 94.6700 },
  ],
  Golaghat: [
    { lat: 26.5330, lng: 93.9600 },
    { lat: 26.5500, lng: 93.9600 },
    { lat: 26.5500, lng: 93.9900 },
    { lat: 26.5330, lng: 93.9900 },
  ],
  Darrang: [
    { lat: 26.7500, lng: 92.2000 },
    { lat: 26.7700, lng: 92.2000 },
    { lat: 26.7700, lng: 92.2300 },
    { lat: 26.7500, lng: 92.2300 },
  ],
  Barpeta: [
    { lat: 26.3000, lng: 91.0000 },
    { lat: 26.3200, lng: 91.0000 },
    { lat: 26.3200, lng: 91.0300 },
    { lat: 26.3000, lng: 91.0300 },
  ],
  Hojai: [
    { lat: 26.7500, lng: 92.9500 },
    { lat: 26.7700, lng: 92.9500 },
    { lat: 26.7700, lng: 92.9800 },
    { lat: 26.7500, lng: 92.9800 },
  ],
};

function isPointInPolygon(point, polygon) {
  let x = point.lat, y = point.lng;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    let xi = polygon[i].lat, yi = polygon[i].lng;
    let xj = polygon[j].lat, yj = polygon[j].lng;

    let intersect =
      ((yi > y) !== (yj > y)) &&
      (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
}

useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      const userRef = doc(db, 'user-data', user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const data = userSnap.data();

        // Set user form data
        setFormData((prev) => ({
          ...prev,
          email: data.email || '',
          name: data.name || '',
        }));

        // Set plan type
        setPlanType(data.purchasedPack || 'Basic');

        // Set admin flag
        setIsAdmin(data.role === 'admin'); // <-- HERE
      } else {
        console.warn("User document not found.");
        setPlanType('Basic');
        setIsAdmin(false); // <-- fallback
      }
    }
  });

  return () => unsubscribe();
}, []);

 const getLocationDetailsSingleCall = async (latitude, longitude) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

  try {
    const response = await fetch(geocodeUrl);
    const data = await response.json();

    if (!data.results?.length) throw new Error("No geocode data found");

    const addressComponents = data.results[0].address_components;
    const formattedAddress = data.results[0].formatted_address;

    const getComponent = (type) =>
      addressComponents.find((c) => c.types.includes(type))?.long_name || "";

    const city = getComponent("locality") || getComponent("administrative_area_level_2");
    const state = getComponent("administrative_area_level_1");
    const postalCode = getComponent("postal_code");

    // ✅ Use nearby roads from the geocode results
    const roadResults = data.results.filter((r) =>
      r.types.includes("route")
    );

    // ✅ Helper: Calculate distance (Haversine formula)
    const toRad = (val) => (val * Math.PI) / 180;
    const getDistanceKm = (lat1, lon1, lat2, lon2) => {
      const R = 6371;
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    };

    // ✅ Construct nearby roads array
    const nearbyRoads = roadResults.map((r) => {
      const roadName = r.address_components.find((c) =>
        c.types.includes("route")
      )?.long_name;

      const loc = r.geometry?.location;
      let distanceText = "";

      if (loc) {
        const distKm = getDistanceKm(latitude, longitude, loc.lat, loc.lng);
        distanceText = `${distKm.toFixed(1)} km`;
      }

      return {
        name: roadName || "Unknown Road",
        distance: distanceText,
      };
    });

    return {
      city,
      state,
      postalCode,
      fullAddress: formattedAddress,
      nearbyRoads,
    };
  } catch (error) {
    console.error("Error in getLocationDetailsSingleCall:", error);
    return {
      city: "Unknown",
      state: "Unknown",
      postalCode: "",
      fullAddress: "",
      nearbyRoads: [],
    };
  }
};


const amenityIcons = {
  'Electric Backup': <FaSnowflake />,    
  'Water Supply': <FaTint />,
  'Fans and Lighting': <FaLightbulb />,  
  'Modular Kitchen': <FaUtensils />,
  'Wardrobes': <FaBox />,                 
  'Security': <FaMapMarkerAlt />,
  'Lift/Elevator': <FaArrowUp />,         
  'Parking': <FaCar />,                 
  'Balcony': <FaDoorOpen />,              
  'Swimming Pool': <FaSwimmingPool />,    
  'Pet Friendly': <FaPaw />,              
  'Gas Pipeline': <FaFire />             
};

const amenitiesList = [
  'Electric Backup',
  'Water Supply',
  'Fans and Lighting',
  'Modular Kitchen',
  'Wardrobes',
  'Security',
  'Lift/Elevator',
  'Parking',
  'Balcony',
  'Swimming Pool',
  'Pet Friendly',
  'Gas Pipeline'
];
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};

// Toggle amenities
const handleAmenityToggle = (amenity) => {
  setFormData((prev) => {
    const added = prev.amenities.includes(amenity);
    return {
      ...prev,
      amenities: added
        ? prev.amenities.filter((a) => a !== amenity)
        : [...prev.amenities, amenity],
    };
  });
};

// Detect scroll to bottom
const handleScroll = (e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;
  if (scrollTop + clientHeight >= scrollHeight - 10) {
    setHasScrolledToBottom(true);
  }
};

// Map handling
const handleMapClick = () => setShowMap(true);

const handleLocationSelect = async (googleLink) => {
  const { lat, lng } = await extractLatLngFromGoogle(googleLink);

  if (!lat || !lng) {
    alert("❌ Could not extract latitude and longitude from the link.");
    return;
  }

  let detectedCity = '';
  for (const city in cityBoundaries) {
    if (isPointInPolygon({ lat, lng }, cityBoundaries[city])) {
      detectedCity = city;
      break;
    }
  }

  setFormData((prev) => ({
    ...prev,
    mapLink: googleLink,
    latitude: lat,
    longitude: lng,
    city: detectedCity || 'Unknown',
  }));
};


// OTP send
const API_URL = process.env.REACT_APP_API_BASE || "http://localhost:4000";

const sendOtp = async () => {
  if (!formData.whatsapp.startsWith('+91')) {
    alert('Enter phone number with +91');
    return;
  }
  try {
    const res = await fetch(`${API_URL}/api/send-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone: formData.whatsapp }),
    });

    // If server sends HTML error, avoid JSON parse crash
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Server error: ${text}`);
    }

    const data = await res.json();
    if (data.success) {
      setOtpSent(true);
      alert('✅ OTP sent successfully.');
    } else {
      alert('❌ Failed to send OTP: ' + data.error);
    }
  } catch (err) {
    console.error(err);
    alert('❌ Error sending OTP: ' + err.message);
  }
};

const verifyOtp = async () => {
  try {
    const res = await fetch(`${API_URL}/api/verify-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: formData.whatsapp, otp }),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Server error: ${text}`);
    }

    const data = await res.json();
    if (data.success) {
      setPhoneVerified(true);
      alert('✅ Phone number verified!');
    } else {
      alert('❌ Invalid OTP.');
    }
  } catch (error) {
    console.error('❌ Error verifying OTP:', error);
    alert(`❌ Error: ${error.message}`);
    setLoading(false);
  }
};

// Thumbnail handling
// Thumbnail Upload with Compression
const handleThumbnailChange = async (e) => {
  const file = e.target.files[0];
  if (file) {
    if (!file.type.startsWith("image/")) {
      alert("Only image files are allowed for thumbnails.");
      return;
    }

    try {
         const options = {
  maxSizeMB: 0.5,          // smaller
  maxWidthOrHeight: 800,   // smaller resolution
  useWebWorker: true,
};


      const compressedFile = await imageCompression(file, options);

      setThumbnail(compressedFile);
      setThumbnailPreview(URL.createObjectURL(compressedFile));
    } catch (error) {
      console.error("Thumbnail compression error:", error);
    }
  }
};

// Cover Images Upload with Compression
const handleCoverImagesChange = async (e) => {
  const files = Array.from(e.target.files);

  let maxImages = 4; // default for Basic
  if (planType === "verified") maxImages = 6;
  else if (planType === "featured") maxImages = 8;

  const totalImages = coverImages.length + files.length;

  if (totalImages > maxImages) {
    const allowedToAdd = maxImages - coverImages.length;

    if (allowedToAdd <= 0) {
      alert(`You can upload up to ${maxImages} cover images for the ${planType} plan.`);
      return;
    } else {
      alert(`Only ${allowedToAdd} more image(s) can be added.`);
      files.splice(allowedToAdd); // keep only allowed count
    }
  }

  try {
    const options = {
      maxSizeMB: 1.2,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    };

    const compressedFiles = await Promise.all(
      files.map((file) => imageCompression(file, options))
    );

    setCoverImages((prev) => [...prev, ...compressedFiles]);
    setCoverPreviews((prev) => [
      ...prev,
      ...compressedFiles.map((file) => URL.createObjectURL(file)),
    ]);
  } catch (error) {
    console.error("Cover image compression error:", error);
  }
};

// Remove Thumbnail
const removeThumbnail = () => {
  setThumbnail(null);
  setThumbnailPreview(null);
};

// Remove Cover Image
const removeCoverImage = (index) => {
  setCoverImages((prev) => prev.filter((_, i) => i !== index));
  setCoverPreviews((prev) => prev.filter((_, i) => i !== index));
};

// Video Upload with Validation
const handleVideoChange = (e) => {
  const file = e.target.files[0];

  if (file) {
 if (file.type !== "video/mp4") {
  setVideoError("Only MP4 videos are allowed. Please convert your video to MP4 before uploading.");
  return;
}

    const fileSizeMB = file.size / (1024 * 1024);

    if (fileSizeMB > 5) {
      setVideoError("Video must be less than 5MB.");
      setVideoFile(null);
      setVideoPreview(null);
      return;
    }

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);

      if (video.duration > 60) {
        setVideoError("Video must be less than 60 seconds.");
        setVideoFile(null);
        setVideoPreview(null);
      } else {
        setVideoError("");
        setVideoFile(file);
        setVideoPreview(URL.createObjectURL(file));
      }
    };

    video.src = URL.createObjectURL(file);
  }
};
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

if (!isAdmin && !phoneVerified) {
  alert("❌ Please verify your WhatsApp number with OTP before submitting.");
  setLoading(false);
  return;
}
  // 1. Required fields check
  for (const key in formData) {
    if (
      formData[key] === '' ||
      (Array.isArray(formData[key]) && formData[key].length === 0)
    ) {
      alert(`❌ Please fill out the "${key}" field.`);
      setLoading(false);
      return;
    }
  }

  

  // 3. Description validation
  if (formData.description.length < 15) {
    alert('❌ Description should be at least 15 characters long.');
    setLoading(false);
    return;
  }

  // 5. Address validation
  if (!/^[A-Z].{9,}$/.test(formData.address)) {
    alert('❌ Address should start with a capital letter and be at least 10 characters long.');
    setLoading(false);
    return;
  }

  try {
    const user = auth.currentUser;
    if (!user) {
      alert("❌ User not signed in.");
      setLoading(false);
      return;
    }

    if (parseInt(formData.rent) < 0) {
      alert("❌ Rent can't be negative.");
      setLoading(false);
      return;
    }

 if (!agreed) {
  alert("Please read and accept the agreement.");
  return;
}
let locationData = { city: '', state: '', postalCode: '', fullAddress: '' };
let nearbyRoads = [];


if (formData.latitude && formData.longitude) {
  locationData = await getLocationDetailsSingleCall(formData.latitude, formData.longitude);
  formData.city = locationData.city;
  formData.state = locationData.state;
  formData.postalCode = locationData.postalCode;
  formData.fullAddress = locationData.fullAddress;
  formData.nearbyRoads = locationData.nearbyRoads;
}


    const planLimits = {
      basic: 2,
      verified: 5,
      featured: 10,
      unlimited: Infinity, // optional fallback if you add this plan later
    };

    const listingId = generateCustomListingId();
    const createdAt = new Date();

    const userRef = doc(db, 'user-data', user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      alert("❌ User data not found.");
      setLoading(false);
      return;
    }

    const userData = userSnap.data();
    console.log("User data:", userData);

    // 🧠 Get actual plan name
    const plan = Array.isArray(userData.purchasedPack)
      ? userData.purchasedPack[0]
      : userData.purchasedPack || 'basic'; // fallback

    // 🧠 Validate active plan
    if (userData.planStatus !== "active") {
      alert("⚠️ Your plan is not active.");
      return;
    }

    // 🧠 Validate date-based expiry
    const now = new Date();
    if (userData.validity?.toDate?.() && now > userData.validity.toDate()) {
      alert("⚠️ Your plan has expired.");
      return;
    }

    // ✅ Limit listing count
    const listingUsed = Number(userData.listingUsed || 0);
    const maxListing = Number(userData.maxListing || planLimits[plan] || 0);

    if (listingUsed >= maxListing) {
      alert(`🚫 You have used all ${maxListing} listings in your plan (${plan}).`);
      setLoading(false);
      return;
    }
let billURL = null;
// ✅ Rent Bill Upload + OCR Verification
if (plan === 'featured' || plan === 'verified') {
  if (!billFile) {
    alert('❌ Please upload your rent bill for verification.');
    setLoading(false);
    console.warn("⚠️ Rent bill file not provided.");
    return;
  }

  try {
    const billRef = ref(storage, `housebills/${listingId}/${billFile.name}`);
    await uploadBytes(billRef, billFile);
    billURL = await getDownloadURL(billRef);  // <== store URL
    console.log("Bill uploaded at:", billURL);
  } catch (error) {
    console.error("❌ Error during rent bill upload:", error);
    setLoading(false);
    return;
  }
}


  // 🔥 Upload thumbnail
// 🔥 Upload thumbnail
let thumbnailURL = '';
let thumbnailPath = '';
if (thumbnail) {
  const thumbRef = ref(storage, `pg-listing/thumbnails/${listingId}/thumbnail.jpg`);
  await uploadBytes(thumbRef, thumbnail);
  thumbnailURL = await getDownloadURL(thumbRef); 
  thumbnailPath = thumbRef.fullPath; // store the storage path
}

// 🔥 Upload slot images (covers)
let coverImageURLs = [];
let slotImagePaths = [];
if (coverImages && coverImages.length > 0) {
  await Promise.all(
    coverImages.map(async (file, index) => {
      const coverRef = ref(storage, `pg-listing/covers/${listingId}/cover_${index}.jpg`);
      await uploadBytes(coverRef, file);
      const url = await getDownloadURL(coverRef);
      coverImageURLs.push(url);
      slotImagePaths.push(coverRef.fullPath); // store the storage path
    })
  );
}


    let videoURL = null;
    let videoPath = null;

    // 🎥 Upload video if Premium (featured plan)
    if (plan === 'featured' && videoFile) {
      try {
        console.log("📦 Uploading video file:", videoFile);

        if (!videoFile || !(videoFile instanceof File)) {
          console.error("❌ Invalid video file.");
          return;
        }

        // Define path & upload video
        videoPath = `property-videos/${Date.now()}_${videoFile.name}`;
        const videoRef = ref(storage, videoPath);
        const videoSnapshot = await uploadBytes(videoRef, videoFile);
        console.log("✅ Video uploaded successfully:", videoSnapshot);

        // Get the download URL
        videoURL = await getDownloadURL(videoRef);
        console.log("📽️ Video URL:", videoURL);

        // Save to Firestore directly for rent-listings
        const listingRef = doc(db, 'rent-listings', listingId);
        await updateDoc(listingRef, {
          videoURL,
          videoPath,
          videoUploadedAt: new Date(),
        });

        console.log("✅ Video URL saved to Firestore");
      } catch (error) {
        console.error("❌ Error uploading or saving video:", error);
      }
    }

    // ✅ Final Firestore Listing Upload
    const data = {
      ...formData,
      createdAt,
      verified: phoneVerified,
     
      ownerId: user.uid,
    };

    // Flags based on plan type
    let isPremium = false;
    let isVerified = false;

    if (plan === 'featured') {
      isPremium = true;
      isVerified = true;
    } else if (plan === 'verified') {
      isVerified = true;
    }

    // Merge flags into data object
  const listingData = {
  ...data,
  isPremium,
  isVerified,
  plan,
  createdAt: new Date(),
  thumbnailURL,
  city: formData.city,
  state: formData.state,
  fullAddress: formData.fullAddress,
  coverImageURLs,
  nearbyRoads: formData.nearbyRoads.map(road => ({
    name: road.name,
    distance: road.distance
  })),
  thumbnailPath,
  slotImagePaths,
  listingId,
  ...(videoURL && { videoURL }),
  ...(videoPath && { videoPath }),
  ...(videoURL && { videoUploadedAt: new Date() }),
  ...(billURL && { billURL }),
};

    await setDoc(doc(db, 'rent-listings', listingId), listingData, { merge: true });

 await setDoc(userRef, {
  listingUsed: listingUsed + 1
}, { merge: true });

    console.log(`✅ Updated listingUsed: ${listingUsed + 1} (Plan: ${plan}, Limit: ${maxListing})`);

    alert('✅ Listing submitted successfully!');
   navigate("/homepage/listings", { replace: true });

  } catch (error) {
    console.error('❌ Error submitting listing:', error);
    alert(`❌ Error: ${error.message}`);
  }

  setLoading(false);
};






return (
  <div className="form-wrapper gradient-bg">
    {/* ✅ Loading overlay */}
    {loading && (
      <div className="loading-overlay">
        <div className="loading-spinner"></div>
        <div className="loading-text">
          Please wait while we list your house.<br />
          It might take a few minutes depending on your internet.
        </div>
      </div>
    )}

    <h2>List Your Rental Property</h2>
    <form onSubmit={handleSubmit}>
      <h3>Property Details</h3>
      <label>Property Name: </label>
      <input 
        type="text" 
        name="pgName" 
        value={formData.pgName} 
        onChange={handleChange} 
        placeholder="e.g. Sunrise Apartments"
      />

 <select name="occupancy" value={formData.occupancy} onChange={handleChange}>
  <option value="">Select Occupancy Type</option>
  <option value="Family">Family</option>
  <option value="Professional">Professional</option>
  <option value="Students">Students</option>
  <option value="Everyone">Everyone</option>
</select>

 <label>Room Type:</label>
<select name="roomType" value={formData.roomType} onChange={handleChange}>
  <option value="">Select Your Room Type</option>
  <option value="1BHK">1BHK</option>
  <option value="2BHK">2BHK</option>
  <option value="3BHK">3BHK</option>
  <option value="4BHK">4BHK</option>
  <option value="5BHK">5BHK</option>
  <option value="6BHK">6BHK</option>
</select>

      <label>Description:</label>
      <textarea 
        name="description" 
        value={formData.description} 
        onChange={handleChange} 
        placeholder="Tell us something about your rental property" 
      />

      <h3>Lister Information</h3>
      <label>Full Name:</label>
      <input 
        type="text" 
        name="name" 
        value={formData.name} 
        onChange={handleChange} 
        placeholder="Your Full Name" 
      />

      <label>WhatsApp Number (+91...):</label>
      <input 
        type="text" 
        name="whatsapp" 
        value={formData.whatsapp} 
        onChange={handleChange} 
        placeholder="Your WhatsApp Number" 
      />

      {/* Show OTP button only if user is NOT admin */}
{!isAdmin && !otpSent && (
  <button type="button" onClick={sendOtp}>Send OTP</button>
)}

{!isAdmin && otpSent && !phoneVerified && (
  <>
    <input
      type="text"
      placeholder="Enter OTP"
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
    />
    <button type="button" onClick={verifyOtp}>Verify OTP</button>
  </>
)}
        {phoneVerified && <p style={{ color: 'green' }}>✅ Phone verified</p>}

      <label>Preferred Contact Time:</label>
      <input 
        type="text" 
        name="contactTime" 
        value={formData.contactTime} 
        onChange={handleChange} 
        placeholder="e.g. 10 AM - 7 PM" 
      />

      <h3>Amenities</h3>
      <div className="amenities-grid">
        {amenitiesList.map((item, i) => (
          <label key={i} className="amenity-label">
            <input
              type="checkbox"
              checked={formData.amenities.includes(item)}
              onChange={() => handleAmenityToggle(item)}
            />
            <span className="icon">{amenityIcons[item] || '❓'}</span>
            <span className="text">{item}</span>
          </label>
        ))}
      </div>

      <h3>Property Location</h3>
      <label>
        Map Link (Click to choose):
        <span onClick={handleMapClick} className="map-icon">
          <FaMapMarkerAlt />
        </span>
      </label>
      <input 
        type="text" 
        name="mapLink" 
        value={formData.mapLink} 
        onChange={handleChange} 
        placeholder="Choose your property location from the map" 
      />

      <label>Address:</label>
      <textarea 
        name="address" 
        value={formData.address} 
        onChange={handleChange} 
        placeholder="Your property address" 
      />

      <h3>Rent Details</h3>
      <label>Rent (Rs/-Month):</label>
      <input
        type="number"
        name="rent"
        value={formData.rent}
        min="0"
        onChange={handleChange}
        placeholder="e.g. 5000"
      />

      <label>Security Deposit:</label>
      <select name="deposit" value={formData.deposit} onChange={handleChange}>
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>

      <label>Negotiable?</label>
      <select name="negotiable" value={formData.negotiable} onChange={handleChange}>
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>

      {/* Thumbnail Upload + Preview */}
      <h3>Upload Property Photos</h3>
      <label>Upload Thumbnail:</label>
      {thumbnailPreview && (
        <div className="image-preview">
          <img src={thumbnailPreview} alt="Thumbnail Preview" />
          <button type="button" onClick={removeThumbnail}>Remove</button>
        </div>
      )}
      <input type="file" accept="image/*" onChange={handleThumbnailChange} />

      {/* Cover Images Upload + Preview */}
      <label>Upload Cover Images:</label>
      <p style={{ fontWeight: "bold", marginTop: "10px" }}>
        Uploaded {coverImages.length} / 
        {planType === 'verified' ? '6' : planType === 'featured' ? '8' : '4'} images
      </p>

      <input type="file" accept="image/*" multiple onChange={handleCoverImagesChange} />

      <div className="cover-preview-grid">
        {coverPreviews.map((src, index) => (
          <div key={index} className="image-preview">
            <img src={src} alt={`Cover ${index + 1}`} />
            <button type="button" onClick={() => removeCoverImage(index)}>Remove</button>
          </div>
        ))}
      </div>

      {(planType === 'featured' || planType === 'verified') && (
        <div className="rent-bill-upload">
          <h3>Upload Rent Bills</h3>
          <label>Upload Rent Bills (Required)</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setBillFile(e.target.files[0])}
          />
        </div>
      )}

      

      {planType === 'featured' && (
 <div>
  <label>Upload a 60-second Video (MP4 only, max 5MB):</label>
  <input
    type="file"
    accept="video/mp4"
    onChange={(e) => {
      const file = e.target.files[0];
      if (!file) return;

      // ✅ Check file type (only MP4)
      if (file.type !== "video/mp4") {
        setVideoError("Only MP4 videos are allowed. Please convert your video before uploading.");
        setVideoFile(null);
        setVideoPreview(null);
        return;
      }

      // ✅ Check file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        setVideoError("Video file size should not exceed 5MB.");
        setVideoFile(null);
        setVideoPreview(null);
        return;
      }

      // ✅ All checks passed
      setVideoFile(file);
      setVideoPreview(URL.createObjectURL(file));
      setVideoError("");
    }}
  />

  {videoError && <p style={{ color: "red", marginTop: "5px" }}>{videoError}</p>}

  {videoPreview && (
    <div style={{ marginTop: "10px" }}>
      <video
        width="100%"
        height="auto"
        controls
        src={videoPreview}
        onError={() => setVideoError("Error loading video preview.")}
      />
    </div>
  )}
</div>

)}

<h3>Owner Agreement</h3>
<div
  className="agreement-box"
  onScroll={(e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setHasScrolledToBottom(true);
    }
  }}
>
  <p>
  <strong>PG Listing Terms and Conditions</strong><br /><br />

 By submitting your Paying Guest (PG) property listing on our platform, you agree to the following terms and conditions, which constitute a binding agreement between you and [Platform Name].<br /><br />

  <strong>1. Accuracy of Information:</strong><br />
  You certify that all information provided in your listing — including property details, pricing, images, location, amenities, rules, and contact information — is accurate, current, and complete to the best of your knowledge. Misrepresentation or falsification of information may result in the suspension or permanent removal of your listing.<br /><br />

  <strong>2. Legal Compliance:</strong><br />
  You agree to comply with all applicable local, state, and national laws and regulations, including those governing residential rental properties, taxation, fire safety, occupancy limits, and tenant rights. It is your sole responsibility to ensure legal compliance for the operation and advertisement of your PG accommodation.<br /><br />

  <strong>3. Maintenance and Safety:</strong><br />
  As the property owner or authorized representative, you are fully responsible for maintaining the condition, hygiene, safety, and functionality of the PG property. You must promptly address maintenance issues and ensure the property meets reasonable living standards at all times.<br /><br />

  <strong>4. Liability Disclaimer:</strong><br />
  [Your Company Name] acts solely as a listing platform and is not involved in any rental transaction or agreement between the Owner and Tenant. We do not verify the credentials of tenants or guarantee bookings. The Platform assumes no liability for disputes, damages, losses, or legal claims arising between parties as a result of the listing.<br /><br />

  <strong>5. Content Moderation:</strong><br />
  The Platform reserves the right to review, moderate, edit, or remove any listing content that is deemed inappropriate, misleading, incomplete, or in violation of our policies or community standards. Repeat violations may result in permanent account suspension.<br /><br />

  <strong>6. Listing Usage Rights:</strong><br />
  By posting your listing, you grant the Platform a royalty-free, worldwide license to display, distribute, and promote your listing content, including text and images, for marketing, search, and user engagement purposes.<br /><br />

  <strong>7. Account Suspension:</strong><br />
  Listings that are repeatedly flagged for issues such as misrepresentation, poor property conditions, harassment, or tenant complaints may be subject to review. If found valid, your account may be suspended or banned at the sole discretion of the Platform.<br /><br />

  <strong>8. Agreement Acceptance:</strong><br />
  By checking the box below and submitting your listing, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. You also agree to be notified of future updates to these terms via email or platform notifications.<br /><br />

  <em>Last updated: August 2025<br />
  © ApkaGhr. All rights reserved.</em>
</p>
</div>
<label>
  <input
    type="checkbox"
    disabled={!hasScrolledToBottom}
    checked={agreed}
    onChange={(e) => setAgreed(e.target.checked)}
  />
  I have read and agree to the terms.
</label>
{/* Professional info note */}
<div className="info-note">
  <span className="info-icon">ℹ️</span>
  Any information submitted that is found to be false, suspicious, or misleading may be removed. 
  The platform holds no liability for such content, and owners are responsible for the accuracy of their listings.
</div>

{/* Red warning for sensitive uploads */}
<div className="red-warning">
  ⚠️ Rent bills, photos, and location details uploaded must be genuine. Only Verified and Premium users can upload these documents. 
  Providing fake bills or incorrect credentials gives us the right to delete your listing to maintain platform integrity.
</div>

<button 
  type="submit" 
  disabled={loading || (!isAdmin && !phoneVerified)}
>
  {loading ? 'Uploading...' : 'Submit Listing'}
</button>

    </form>



      {showMap && (
  <MapModal
    onClose={() => setShowMap(false)}
    onLocationSelect={handleLocationSelect}
  />
)}


    
  </div>
);
}

export default RentListingForm;

                

